'use client';

import { useEffect } from 'react';

// GTM dataLayer'a event push etmek için type declaration
declare global {
  interface Window {
    dataLayer: any[];
  }
}

export default function GTMEvents() {
  useEffect(() => {
    // GTM dataLayer'ın yüklendiğinden emin ol
    window.dataLayer = window.dataLayer || [];

    // GTM event push function
    const gtmPush = (eventName: string, eventData: any = {}) => {
      window.dataLayer.push({
        event: eventName,
        ...eventData
      });
    };

    // Track 404 errors
    if (window.location.pathname.includes('404') || document.title.includes('404')) {
      gtmPush('page_404', {
        page_title: '404 - Page Not Found',
        page_location: window.location.href,
        error_type: '404_error'
      });
    }

    // Track phone clicks
    const handlePhoneClick = (e: Event) => {
      const target = e.target as HTMLElement;
      if (target.closest('a[href^="tel:"]')) {
        const phoneNumber = target.closest('a')?.getAttribute('href')?.replace('tel:', '');
        gtmPush('phone_click', {
          event_category: 'contact',
          event_label: 'phone_number',
          phone_number: phoneNumber,
          click_text: target.textContent || '',
          page_location: window.location.href
        });
      }
    };

    // Track scroll depth
    let maxScrollDepth = 0;
    const handleScroll = () => {
      const scrollDepth = Math.round((window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100);
      if (scrollDepth > maxScrollDepth && scrollDepth % 25 === 0) {
        maxScrollDepth = scrollDepth;
        gtmPush('scroll_depth', {
          event_category: 'engagement',
          event_label: `${scrollDepth}%`,
          scroll_depth: scrollDepth,
          page_location: window.location.href
        });
      }
    };

    // Track time on page
    const startTime = Date.now();
    const trackTimeOnPage = () => {
      const timeSpent = Math.round((Date.now() - startTime) / 1000);
      if (timeSpent > 0 && timeSpent % 30 === 0 && timeSpent <= 300) { // Every 30 seconds, up to 5 minutes
        gtmPush('time_on_page', {
          event_category: 'engagement',
          event_label: `${timeSpent}s`,
          time_spent: timeSpent,
          page_location: window.location.href
        });
      }
    };

    // Track external link clicks
    const handleExternalLinkClick = (e: Event) => {
      const target = e.target as HTMLElement;
      const link = target.closest('a[href^="http"]') as HTMLAnchorElement;
      if (link && !link.href.includes(window.location.hostname)) {
        gtmPush('external_link_click', {
          event_category: 'outbound',
          event_label: link.href,
          link_url: link.href,
          link_text: link.textContent || '',
          page_location: window.location.href
        });
      }
    };

    // Add event listeners
    document.addEventListener('click', handlePhoneClick);
    document.addEventListener('click', handleExternalLinkClick);
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Time tracking interval
    const timeInterval = setInterval(trackTimeOnPage, 30000);

    // Track page view with additional data
    gtmPush('custom_page_view', {
      page_title: document.title,
      page_location: window.location.href,
      page_path: window.location.pathname,
      business_type: 'accounting_service',
      service_area: 'Denizli',
      timestamp: new Date().toISOString()
    });

    // Cleanup function
    return () => {
      document.removeEventListener('click', handlePhoneClick);
      document.removeEventListener('click', handleExternalLinkClick);
      window.removeEventListener('scroll', handleScroll);
      clearInterval(timeInterval);
    };
  }, []);

  return null;
} 